


































import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";

import Loader from "@/modules/externals/components/Loader.vue";
import Paginate from "vuejs-paginate";
import EmptyTable from "../components/EmptyTable.vue";
import TableLoader from "@/modules/externals/components/TableLoader.vue";
import { ApplicantWarning } from "../types";

const Applicants = namespace("applicant");

@Component({
  components: {
    loader: Loader,
    paginate: Paginate,
    "empty-table": EmptyTable,
    "table-loader": TableLoader,
  },
})
export default class ApplicantWarningTable extends Vue {
  @Prop({ required: true }) readonly warnings!: ApplicantWarning[];












}
